import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { Subscription } from 'rxjs/Subscription';
import { JackpotService } from '@app/core/jackpot.service';
import { Router } from '@angular/router';
import { IWagerData, WagerService } from '@app/core/wager.service';

@Component({
  selector: 'app-chest-wager-mobile',
  templateUrl: './chest-wager.template.html',
  styleUrls: ['./chest-wager.template.scss'],
})
export class ChestWagerMobileComponent implements OnInit, OnChanges, OnDestroy {
  jackpotUserInfo$: Subscription = null;
  wagerData$: Subscription = null;
  chests: number = 0;
  keys: number = 0;
  wagered: number = 0;
  needToWager: number = 0;
  showDropdown: boolean = false;
  progress: number = 0;

  remainingWager: number = 0;

  constructor(
    public auth: AuthenticationService,
    private jackpotService: JackpotService,
    private wagerService: WagerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.wagerData$ = this.wagerService.wagerData$.subscribe(
      (wager: IWagerData) => {
        this.wagered = Math.round(wager.progress * 100) / 100;
        this.needToWager = Math.round(wager.target * 100) / 100;
        this.remainingWager = Math.round((this.needToWager - this.wagered) * 100) / 100;
        if (this.remainingWager < 0) {
          this.remainingWager = 0;
        }
        const pgs = (this.wagered / this.needToWager) * 100;
        this.progress = Math.min(pgs, 100);
      },
      () => {}
    );

    this.jackpotUserInfo$ = this.jackpotService.info$.subscribe((data: any) => {
      if (data) {
        this.chests = data.chests;
        this.keys = data.keys.length;
      }
    });
  }

  ngOnChanges() {
    if (this.wagerData$) {
      this.wagerData$.unsubscribe();
    }

    if (this.jackpotUserInfo$) {
      this.jackpotUserInfo$.unsubscribe();
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/chest-wager-mobile/chest-wager.component.ts